import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import { Link } from "react-router-dom";
import SparkApi from "../../api/SparkApi";
import InfoPill from "../InfoPill";
import { usePermission } from "../context/PermissionContext";

const Warehouse = ({ factoryId }) => {
  const navigate = useNavigate();
  const [body, setBody] = useState();
  //const [accounts, setAccounts] = useState();
  const { permissionData , userInfo } = usePermission();
  const can_create = permissionData?.Warehouse?.can_create;
  const can_read = permissionData?.Warehouse?.can_read;


  useEffect(() => {
    async function init() {
      try {
        if(can_read){
        const result = await SparkApi.fetchWarehouse();

        const filteredResult = factoryId
          ? result.filter((warehouse) => warehouse.factory_id === factoryId)
          : result;

        setBody(filteredResult);
      }
      } catch (error) {
        setBody([]);
      }
    }
    init();
  }, [factoryId]);

  const capitalizeWords = (str) =>
    str.replace(/\b\w/g, (char) => char.toUpperCase());

  const header = [
    {
      title: "Name",
      prop: "name",
      isFilterable: true,
      isSortable:true,
      cell: (row) => (
        <Link to={"/warehouse/" + row.id} state={row}>
          {capitalizeWords(row.name)}
        </Link>
      ),
    },
    { title: "Factory", prop: "factory_name", isFilterable: true, isSortable:true,},
    { title: "Country", prop: "country", isFilterable: true, isSortable:true, },
    { title: "State", prop: "state", isFilterable: true, isSortable:true, },
    { title: "City", prop: "city", isFilterable: true, isSortable:true, },
    { title: "Pincode", prop: "pincode", isFilterable: true, isSortable:true, },
  ];

  const labels = { beforeSelect: " " };
  const createWarehouse = () =>
    navigate(`/warehouse/e`, { state: { factory_id: factoryId } });

  return (
    <Container>
      <Row className="g-0">
        <Col lg={12}>
          <DatatableWrapper
            body={body || []}
            headers={header}
            paginationOptionsProps={{
              initialState: { rowsPerPage: 10, options: [5, 10, 15, 20] },
            }}
          >
            <Row className="mb-4">
              <Col xs={12} lg={4} sm={4} className="d-flex flex-col justify-content-end align-items-end">
                <Filter />
              </Col>
              <Col xs={9} sm={6} lg={4} className="d-flex flex-col justify-content-start align-items-start">
                <PaginationOptions labels={labels} />
                <div className="mt-2">
                  <InfoPill left="Total Warehouse" right={body?.length} />
                </div>
              </Col>
              <Col xs={3} sm={2} lg={4} className="d-flex flex-col justify-content-end align-items-end">
                {(userInfo?.userrole === "ADMIN" || can_create && can_read) && <Button
                  className="btn-sm custom-btn-css-add-new-record"
                  variant="outline-primary"
                  onClick={() => createWarehouse(true)}
                >
                  New Warehouse
                </Button>}
              </Col>
            </Row>
            <Table striped className="data-table" responsive="sm">
              <TableHeader />
              {body?.length > 0 ? (
                <TableBody />
              ) : (
                <TableBody>
                  <tr className="text-center">
                    <td colSpan={6}>No record found!</td>
                  </tr>
                </TableBody>
              )}
            </Table>
            <Pagination />
          </DatatableWrapper>
        </Col>
        <Col lg={2}></Col>
      </Row>
    </Container>
  );
};

export default Warehouse;
